/* eslint-disable react-hooks/rules-of-hooks */
import { useTranslation } from 'react-i18next';
import { formatter } from '@repo/shared';
import { type ColumnDef } from '@tanstack/react-table';

import { TextTranslationLeaderboardItem } from '@/api/generated.schemas';
import { ColumnHeader } from '@/components/blocks/data-table/column-header';

export const columns: Array<ColumnDef<TextTranslationLeaderboardItem>> = [
  {
    accessorKey: 'Model',
    header: ({ column }) => {
      const { t } = useTranslation();
      return (
        <ColumnHeader
          column={column}
          title={t('overview.model')}
        />
      );
    },
    cell: ({ row }) => row.original.model,
  },
  {
    accessorKey: 'amountOfModelRuns',
    header: ({ column }) => {
      const { t } = useTranslation();
      return (
        <ColumnHeader
          column={column}
          title={t('overview.amountOfModelRuns')}
          enableSorting
        />
      );
    },
    cell: ({ row }) => row.original.amountOfModelRuns,
  },
  {
    accessorKey: 'cost',
    header: ({ column }) => {
      const { t } = useTranslation();
      return (
        <ColumnHeader
          column={column}
          title={t('metrics.cost')}
          enableSorting
        />
      );
    },
    cell: ({ row }) => formatter.metrics.cost(row.original.cost),
  },
  {
    accessorKey: 'time',
    header: ({ column }) => {
      const { t } = useTranslation();
      return (
        <ColumnHeader
          column={column}
          title={t('metrics.latency')}
          enableSorting
        />
      );
    },
    cell: ({ row }) => formatter.metrics.time(row.original.time),
  },
  {
    accessorKey: 'bleu',
    header: ({ column }) => {
      const { t } = useTranslation();
      return (
        <ColumnHeader
          column={column}
          title={t('metrics.bleu')}
          enableSorting
        />
      );
    },
    cell: ({ row }) => formatter.metrics.bleu(row.original.bleu),
  },
  {
    accessorKey: 'comet',
    header: ({ column }) => {
      const { t } = useTranslation();
      return (
        <ColumnHeader
          column={column}
          title={t('metrics.comet')}
          enableSorting
        />
      );
    },
    cell: ({ row }) => formatter.metrics.comet(row.original.comet),
  },
];
